<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="a-great-man-falls-in-love">
<p style="padding-top:150px;">She was quite a simple girl too, her ambition in the life was just as simple; although she had the power to own the world, but she was always thinking about her own peace. Their relation became strong to the point that he fell in her love. Since that moment his life totally changed. He was a great businessman, and focused his whole life on his work only, he never felt those feelings that he felt with her before. When he told her that he was in love with her, she didn’t say that she loved him. But she liked him, she liked the massive efforts that he paid for her just to make her happy even before and without any promises from her to him, and because he was a really hard worker, He used to travel for her around one hundred and fifty kilometers almost daily or four times a week even before he told her that he is in love with her, until he shifted his life entirely to Dubai because of her. and because He was so honest with her, he was so loyal to her, and the most important thing is that he never disappointed her till she told him one day, “You are a very good person to build a family with you.” They started to get more close. He cared a lot about her, and was always thinking about anything related to her. Most of his habits changed because of his love for her; he loved her hard.</p>
<p>He had never fallen in love with someone else before, he always focused only on his business, so when he fell in love with her, he loved her with all of his heart.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0007.vue?a33b11e2